import { Subject } from 'rxjs';

type tplotOptions = {
    [key: string]: boolean
}
const plotOptions: tplotOptions = {
    "viewToast": true,
    "viewMobileToast": true,
}

export const dataService = {
    setData: (key: any, value: boolean) => { plotOptions[key] = value },
    getData: (key: string) => { return plotOptions[key] }
};